/**
 * PDF Exporter
 *
 * Uses the browser's native print dialog (window.print()) to export the
 * already-rendered report content. The user selects "Save as PDF" in the
 * print dialog. Layout is controlled by @media print CSS rules.
 */

export class PdfExporter {
  exportToPdf(): void {
    window.print();
  }
}

export default new PdfExporter();
